import styled from "styled-components";
import { 
  Space,
  Button as AntButton,
} from "antd";

export const SubTitle = styled.div`
  color: #2A2A2A;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */

  margin: 16px auto 18px;
`;

export const StyledInput = styled.input`
  margin-top: 16px;
  width: 50px !important;
  height: 50px !important;
  border-radius: 8px;
  background: #F4F4F4 !important;
  text-align: center !important;
  border:  ${(props) => (props.status === "error" ? "1px solid red" : "1px solid #DDD7CD")} !important;
  font-size: 16px !important;
  padding: 0;
  color: #000000 !important;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  &:focus{
    border: 1px solid #D66700 !important;
  }

  -moz-appearance: textfield;
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
  @media screen and (max-width: 460px) {
    width: 50px !important;
    height: 50px !important;
  }
  @media screen and (max-width: 380px) {
    width: 45px !important;
    height: 45px !important;
  }
  @media screen and (max-width: 340px) {
    width: 35px !important;
    height: 35px !important;
  }
`;

export const BottomBox = styled(Space)`
  width: 100%;
  margin: 0px 0 16px;

  display: flex;
  justify-content: center;
  align-items: center;

  .ant-space-item:nth-child(1) {
    flex: 1;
  }
`;

export const BottomText = styled(AntButton)`
  cursor: pointer;
  color: #D66700 !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
  text-align: center;
  width: 100%;
  background: none !important;

  :hover{
    color: #D66700 !important;
    background: none !important;
  }
`;

export const TimeText = styled.div`
  color: #D66700 !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
  text-align: center;
`;


